import { gql } from '@apollo/client/core';
import PortfolioCurrentUserFragment from '@/apollo/fragments/Portfolio/PortfolioCurrentUser.fragment';

const PortfolioCurrentUserQuery = gql`
  ${PortfolioCurrentUserFragment}

  query jobsUserProfile {
    currentUser {
      ...PortfolioCurrentUserFragment
    }
  }
`;

export default PortfolioCurrentUserQuery;
